// ════════════════════════════════════════════════════════════════════════════
// iOS / iPadOS (WebKit) TESPİTİ — FE-37
// ════════════════════════════════════════════════════════════════════════════
// NEDEN VAR: iOS'ta gömülü PDF (`<iframe src="....pdf">`) YALNIZ İLK SAYFAYI
// çizer ve kaydırılamaz — WebKit'in gömülü PDF görüntüleyicisi bir "önizleme
// karesi"dir, tam görüntüleyici değil. Bu SESSİZ bir kusurdur: üç sayfalık bir
// iş sözleşmesini açan kullanıcı tek sayfa görür ve belgenin tamamının bu
// olduğunu sanır. Aynı PDF üst-seviye belge olarak açıldığında (yeni sekme)
// iOS kendi TAM görüntüleyicisini kullanır ve bütün sayfaları gösterir.
//
// NEDEN TARAYICI ADI DEĞİL, MOTOR: iOS'ta HER tarayıcı (Chrome, Firefox, Edge,
// Opera) WebKit kullanmak ZORUNDADIR — App Store kuralı. Yani "Safari mi"
// sorusu yanlış sorudur; doğru soru "iOS/iPadOS üzerinde mi"dir.
//
// NEDEN `navigator.platform` DEĞİL: (a) tarayıcılarda kullanımdan kaldırıldı,
// (b) iPadOS 13'ten beri iPad kendini MASAÜSTÜ Mac olarak tanıtır
// ("Macintosh; Intel Mac OS X"). Gerçek Mac'ten ayıran yapısal iz DOKUNMATİK
// destektir: masaüstü Safari'de `maxTouchPoints` 0'dır, iPad'de 5'tir.
//
// Değer MODÜL YÜKLENİRKEN DEĞİL, ÇAĞRILDIĞINDA okunur: testler `navigator`ı
// vaka başına değiştirebilsin, ve sunucu-tarafı/olmayan `navigator` ortamları
// (jsdom öncesi, SSR) patlamasın.
export default function isIosWebKit() {
  if (typeof navigator === 'undefined' || !navigator) return false;

  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;

  // iPadOS 13+ "istek masaüstü site" kipi: UA Macintosh der, dokunmatik ele verir.
  const touchPoints = typeof navigator.maxTouchPoints === 'number' ? navigator.maxTouchPoints : 0;
  return /Macintosh/.test(ua) && touchPoints > 1;
}
